import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import _ from 'lodash';

const Contact = (props) => {
    const { user } = props
    const [classEl, setClass] = useState("");

    useEffect(() => {
        let loaded = true;
        setTimeout(() => {
            if (loaded) setClass("active")
        }, 300)
        return () => {
            loaded = false;
        };
    }, [])

    const alertToast = (text, type = 'warn') => {
        toast[type](text, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    const onSubmit = e => {
        e.preventDefault()
        alertToast("Thanks for your contact!", "success")
    };

    if (_.isEmpty(user)) return false;
    return (

        // {/* <!-- ========== Start Contact ========== --> */}
        <section className={`contact area-bg ${classEl}`} id="contact">
            <div className="container">
                <div className="main-title">
                    <h2>Get In Touch</h2>
                    <h3>Contact Me</h3>
                </div>
                <div className="row">
                    <div className="col-lg-5 col-md-12">
                        <div className="contact-boxes">
                            <div className="contact-box">
                                <div className="contact-box">
                                    <div className="content-box">
                                        <p>
                                            <i className="fa fa-user-circle"></i>
                                            {user.name}
                                        </p>
                                    </div>
                                </div>
                                <div className="content-box">
                                    <p>
                                        <i className="fa fa-home"></i>
                                        {user.address}
                                    </p>
                                </div>
                            </div>
                            <div className="contact-box two">
                                <div className="content-box">
                                    <p>
                                        <i className="fa fa-envelope"></i>
                                        <a href={`mailto:${user.email}`}>{user.email}</a>
                                    </p>
                                </div>
                            </div>
                            {user?.skype && 
                                <div className="contact-box">
                                    <div className="content-box">
                                        <p>
                                            <i className="fa fa-skype"></i>
                                            <a href={`skype:${user.skype}?chat`} target="_blank" rel="noopener noreferrer">{user.skype}</a>
                                        </p>
                                    </div>
                                </div>
                            }
                            {user?.angelist && 
                                <div className="contact-box">
                                    <div className="content-box">
                                        <p>
                                            <i className="fa fa-angellist"></i>
                                            <a href={user.angelist}>{user.angelist}</a>
                                        </p>
                                    </div>
                                </div>
                            }
                            {user?.linkedin &&
                                <div className="contact-box">
                                    <div className="content-box">
                                        <p>
                                            <i className="fa fa-linkedin"></i>
                                            <a href={user.linkedin}>{user.linkedin}</a>
                                        </p>
                                    </div>
                                </div>
                            }
                            <div className="contact-box">
                                <div className="content-box">
                                    <p>
                                        <i className="fa fa-check available"></i>
                                        Freelance Available
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12">
                        <form className="contact-form" onSubmit={onSubmit}>
                            <div className="form-group">
                                <input type="text" className="form-control" id="name" name="name" required />
                                <label htmlFor="name">Name</label>
                                <span className="input-border"></span>
                            </div>
                            <div className="form-group">
                                <input type="email" className="form-control" id="email" name="email" required />
                                <label htmlFor="email">Email</label>
                                <span className="input-border"></span>
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" id="subject" required />
                                <label htmlFor="subject">Subject</label>
                                <span className="input-border"></span>
                            </div>
                            <div className="form-group">
                                <textarea className="form-control" id="message" name="message" required ></textarea>
                                <label htmlFor="message">Your Message</label>
                                <span className="input-border"></span>
                            </div>
                            <button className="contact-btn main-btn btn btn-block" type="submit" >Send Message</button>
                            <div className="form-message text-center"><span></span></div>

                        </form>

                    </div>
                </div>
            </div>
            <div className="copyright">
                <a href="/" onClick={(e) => e.preventDefault()}>{user.name}</a> &copy; 2020 made by love <i className="fa fa-heart"></i>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </section>

        // {/* <!-- ========== End Contact ========== --> */}
    );

}

export { Contact };

